import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthGuard, ConfigModule, UrlModule } from '@spartacus/core';
import { ComponentsModule } from './components/components.module';
import { QuoteConfirmationPage } from './page/quote-confirmation-page.component';
import { OutletPosition, provideOutlet } from '@spartacus/storefront';
import { SharedModule } from '@shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [QuoteConfirmationPage],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    UrlModule,
    ComponentsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CMSParagraphComponent: {
          component: () =>
            import('./components/empty-cart/empty-cart.component').then((m) => m.EmptyCartComponent),
          guards: [AuthGuard],
        },
        CartTotalsComponent: {
          component: () =>
            import('./components/custom-order-summary/custom-order-summary.component').then(
              (m) => m.CustomOrderSummaryComponent
            ),
          guards: [AuthGuard],
        },
        CartComponent: {
          component: () =>
            import('./components/custom-cart/custom-cart.component').then((m) => m.CustomCartComponent),
          guards: [AuthGuard],
        },
        AddToSavedCartsComponent: {
          component: () =>
            import('./components/add-to-saved-cart/add-to-saved-cart.component').then(
              (m) => m.AddToSavedCartComponent
            ),
          guards: [AuthGuard],
        },
        QuoteEditDetailsComponent: {
          component: () =>
            import('./components/custom-quote-edit/custom-quote-edit.component').then(
              (m) => m.CustomQuoteEditComponent
            ),
          guards: [AuthGuard],
        },
        QuoteConfirmComponent: {
          component: () =>
            import('./components/custom-quote-confirm/custom-quote-confirm.component').then(
              (m) => m.CustomQuoteConfirmComponent
            ),
          guards: [AuthGuard],
        },
      },
    }),
  ],
  providers: [
    provideOutlet({
      id: 'QuoteConfirmPageTemplate',
      position: OutletPosition.REPLACE,
      component: QuoteConfirmationPage,
    }),
  ],
})
export class CustomCartModule {}
